import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["symbol"]

import remixiconUrl from '@/components/editor/RemixIcon.vue';
import { PropType } from 'vue';

// Define the props with TypeScript type annotations

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
  icon: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  action: {
    type: Function,
    required: true
  },
  isActive: {
    type: Function,
    default: null
  }
},
  setup(__props) {

const props = __props;

const clickAction = (event: Event) => {
  props.action!(event);
}

return (_ctx: any,_cache: any) => {
  const _directive_svg = _resolveDirective("svg")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["menu-item", { 'is-active': __props.isActive ? __props.isActive() : null }]),
    onClick: clickAction,
    title: __props.title
  }, [
    _withDirectives((_openBlock(), _createElementBlock("svg", {
      symbol: `ri-${__props.icon}`,
      size: "24"
    }, null, 8, _hoisted_2)), [
      [_directive_svg]
    ])
  ], 10, _hoisted_1))
}
}

})